import React, { Component } from "react";
import Button from "../Button";
import styles from "./study-with-us.module.scss";
import Img from "gatsby-image";


function createMarkup(value) {
	return {
		__html: value
	};
}
const StudyWithUs = ({style, title, featuredImage, description}) => (
	<div className={styles.outer_wrapper} style={style}>
		<div className="container">
			<div className={"row justify-content-center justify-content-lg-between " + styles.row}>
				<div className={"col-12 col-md-8 col-lg-7 " + styles.featured_image}>
					
					<Img
							title={featuredImage.title}
							alt={featuredImage.title}
							sizes={featuredImage.sizes}
						/>
				</div>
				<div className={"col-12 col-md-12 col-lg-6 " + styles.featured_post}>
					<h3>{title}</h3>
					<hr className={styles.hr} />
					<span className="text-dark" dangerouslySetInnerHTML={createMarkup(description)} />
					
					{/* <Button to={"/"} buttonLabel={"Contact us"} arrow={true} /> */}
				</div>
			</div>
		</div>
	</div>
);

export default StudyWithUs;



// WEBPACK FOOTER //
// ./src/components/study-with-us/index.js